class Controller {
    constructor() {

        const app = angular.module("configurator", []);
        app.controller("c-basic", ['$scope', $scope => {

            // Funkcja inicjalizująca.
            function init() {
                $scope.state = require('./../common/angular-restore')();
            }

            // Funkcja na sumbit forma.
            $scope.submit = require('./../common/submit.js');

            // Zainicjuj i zakończ ładowanie.
            require('./../common/init')(init);
            window.AH.controllerLoaded();
        }]);
    }
}
export { Controller };